import { HolidaysTypes } from 'date-holidays';
import moment from 'moment';

import { DB_DATE_FORMAT_STRING } from './parseDate';

export const parseHolidayDay = (day: HolidaysTypes.Holiday): string => {
  const d = moment(day.date.split(' ')[0]);
  let output = d;
  if (d.isoWeekday() === 7) {
    output = d.add(1, 'day');
  }
  if (d.isoWeekday() === 6) {
    output = d.add(-1, 'day');
  }
  return output.format(DB_DATE_FORMAT_STRING);
};

// This code goes back to previous month because thursday was 31st of October so it was closer to previous month than to November so we need to walk through the days in loop which was safer
//   const currentNovember = moment().startOf('year').add(10, 'month').day('Thursday');

export function getFridayAfterThanksgiving(): string {
  const NEEDED_DAY_OF_WEEK = 4;
  const currentNovember = moment().month('November').startOf('month');

  if (currentNovember.day() !== NEEDED_DAY_OF_WEEK) {
    do {
      currentNovember.add(1, 'day');
    } while (currentNovember.day() !== NEEDED_DAY_OF_WEEK);
  }
  currentNovember.add(3, 'weeks');

  // // Get the Friday after Thanksgiving
  const output = currentNovember.clone().add(1, 'day');
  return output.format(DB_DATE_FORMAT_STRING);
}
